import { useMutation } from '@tanstack/react-query';

import { getSMPBackendAPIAdmin } from '@/proxy';

function sendBookingSummary({ bookingId, emails }: { bookingId: string; emails: string[] }) {
  return getSMPBackendAPIAdmin().mailsControllerSendServiceBookingSummaryV1(bookingId, { emails });
}

export function useSendBookingSummary() {
  return useMutation({ mutationFn: sendBookingSummary });
}
